import React, { useEffect, useState } from 'react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import { FaBolt, FaCheckCircle } from 'react-icons/fa';
import { motion } from 'framer-motion';

// Animation config
const incrementSpeed = 150;
const maxCoins = 100;

// Clapping animation
const clapAnimation = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.2); }
`;

const StyledContainer = styled(Container)`
  background-color: #000;
  color: #fff;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px;
`;

const Logo = styled.img`
  height: 50px;
  margin-bottom: 20px;
`;

const Message = styled.p`
  font-size: 22px;
  font-weight: bold;
  margin: 5px 0;
  color: #fff;
`;

const CoinsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #1E1E1E;
  border-radius: 12px;
  padding: 10px 15px;
  border: 2px solid #FF7C24;
  font-size: 20px;
  font-weight: bold;
  color: #FFD700;
  margin-top: 10px;
`;

const ScoreContainer = styled.div`
  margin-top: 15px;
  font-size: 18px;
  font-weight: bold;
  color: #2ECC71;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ClappingHands = styled.div`
  font-size: 50px;
  margin-top: 20px;
  animation: ${clapAnimation} 0.6s infinite alternate ease-in-out;
`;

const ContinueButton = styled(Button)`
  background-color: #FF7C24;
  border-color: #FF7C24;
  font-size: 18px;
  font-weight: bold;
  border-radius: 10px;
  padding: 12px 30px;
  width: 100%;
  max-width: 300px;
  margin-top: 30px;
`;

const PostActivationCoinsEarnedPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [coins, setCoins] = useState(0);

  const numberOfOnboardingActivationCorrectAnswers =
    location.state?.numberOfOnboardingActivationCorrectAnswers || 0;

  useEffect(() => {
    let interval;
    if (coins < maxCoins) {
      interval = setInterval(() => {
        setCoins((prev) => (prev < maxCoins ? prev + 10 : maxCoins));
      }, incrementSpeed);
    }
    return () => clearInterval(interval);
  }, [coins]);

  const handleContinue = () => {
    navigate('/post-activation-streak-count');
  };

  return (
    <StyledContainer>
      {/* ✅ Logo */}
      <Logo src="/assets/fintorro-logo.png" alt="FinTorro Logo" />

      {/* ✅ Celebration Text */}
      <Message>🎉 Exciting!</Message>
      <Message>🎉 You have completed your first FinTorro lesson!</Message>

      {/* ✅ Coins Earned Animation */}
      <CoinsContainer>
        <FaBolt color="#FFC107" style={{ marginRight: '8px' }} />
        Coins Earned to spend later: <span style={{ marginLeft: '6px' }}>{coins}</span>
      </CoinsContainer>

      {/* ✅ Correct Answers Display */}
      <ScoreContainer>
        {/* <FaCheckCircle color="#2ECC71" /> */}
        {/* You got <span style={{ color: '#FF7C24' }}>{numberOfOnboardingActivationCorrectAnswers}</span> correct answers! */}
      </ScoreContainer>

      {/* ✅ Clapping Emoji */}
      <ClappingHands>👏</ClappingHands>

      {/* ✅ Continue CTA */}
      <ContinueButton onClick={handleContinue}>Continue</ContinueButton>
    </StyledContainer>
  );
};

export default PostActivationCoinsEarnedPage;

